




































































import { Component, Prop, Vue } from 'vue-property-decorator';
import BoutonChrono from '@/components/Menu/BoutonChrono.vue';

@Component({
	components: {
		BoutonChrono
	}
})
export default class Menu extends Vue {
	private opened: boolean = false;

	get GrandesPeriodes(): any {
		return this.$store.getters['getGrandesPeriodes'];
	}

	get imgMainUrl() {
		if (this.$store.getters.getIsMobile) {
			return require('@/assets/img/menu/logo-mobile.png');
		} else {
			return require('@/assets/img/menu/logo.svg');
		}
	}

	get imgMenuIcon() {
		if (this.opened) {
			return require('@/assets/img/menu/x-menu.svg');
		} else {
			return require('@/assets/img/menu/menu-icon.svg');
		}
	}

	get imgMenuRetour() {
		return require('@/assets/img/menu/menu-retour.svg');
	}

	get imgBackgroundMenu() {
		return require('@/assets/img/menu/fond-menu.jpg');
	}

	private goBack(): void {
		window.location.href = '/decouvrez/ligne-du-temps-chronologie-occupation-territoire';
	}

	private getBackgroundStyle(): any {
		return {
			background:
				'linear-gradient(0deg, rgba(255, 121, 64, 0.95), rgba(255, 121, 64, 0.95)), url("' +
				this.imgBackgroundMenu +
				'")'
		};
	}
}
